import { useEffect } from "react";
import { SITE } from "../data/site";

const DEFAULT_OG_IMAGE = "/img/og-image.jpg";

const absolute = (image) =>
  !image ? `${SITE.domain}${DEFAULT_OG_IMAGE}` : image.startsWith("http") ? image : `${SITE.domain}${image}`;

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const humanize = (seg) => seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const breadcrumbs = (path) => {
  const parts = path.split("/").filter(Boolean);
  const items = [{ "@type": "ListItem", position: 1, name: "Home", item: `${SITE.domain}/` }];
  parts.forEach((seg, i) => {
    items.push({
      "@type": "ListItem",
      position: i + 2,
      name: humanize(seg),
      item: `${SITE.domain}/${parts.slice(0, i + 1).join("/")}`,
    });
  });
  return { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: items };
};

const Seo = ({ title, description, keywords, path, image, type = "website", jsonld }) => {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    if (path) {
      const url = `${SITE.domain}${path}`;
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = url;
      upsertMeta("property", "og:url", url);
      upsertMeta("property", "og:type", type);
      upsertMeta("property", "og:title", title);
      upsertMeta("property", "og:description", description);
      upsertMeta("property", "og:image", absolute(image));
      upsertMeta("name", "twitter:card", "summary_large_image");
      upsertMeta("name", "twitter:title", title);
      upsertMeta("name", "twitter:description", description);
      upsertMeta("name", "twitter:image", absolute(image));

      const id = "seo-jsonld-breadcrumb";
      document.getElementById(id)?.remove();
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(breadcrumbs(path));
      document.head.appendChild(script);
    }
    if (jsonld) {
      const id = "seo-jsonld-dynamic";
      document.getElementById(id)?.remove();
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(jsonld);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, path, image, type, jsonld]);
  return null;
};

export default Seo;
